/// <reference path="../include.ts" />

namespace project_common {

	import LocalStorage = alm.browser.LocalStorage;
	import DeviceInfo = alm.browser.DeviceInfo;
	import Hash = alm.util.Hash;

	export class LangUtil {

		// --------------------------------------------------
		//
		// METHOD
		//
		// --------------------------------------------------

		public static loadLanguage(langList:Lang[]):Lang {
			// detect browser language
			let browserLang:Lang;
			switch (DeviceInfo.getLang()) {
				case 'ja':
					browserLang = Lang.ja;
					break;
				case 'en':
					browserLang = Lang.en;
					break;
				case 'ko':
					browserLang = Lang.ko;
					break;
				case 'th':
					browserLang = Lang.th;
					break;
				case 'zh-hans':
					browserLang = Lang.zhHans;
					break;
				case 'zh-hant':
					browserLang = Lang.zhHant;
					break;
				default:
					browserLang = null;
			}
			trace('[Application] language (browser setting) :', browserLang);

			// get lang from LocalStorage
			let savedLang:Lang = LocalStorage.load('lang', null);
			trace('[Application] language (saved data) :', savedLang);

			// decide language
			if (langList.indexOf(savedLang) !== -1) {
				return savedLang;
			} else if (langList.indexOf(browserLang) !== -1) {
				return browserLang;
			} else if (langList.indexOf(Lang.en) !== -1) {
				return Lang.en;
			} else if (langList.indexOf(Lang.ja) !== -1) {
				return Lang.ja;
			} else {
				return langList[0];
			}
		}

		public static saveLanguage(lang:Lang, apply:boolean = true):void {
			LocalStorage.saveWithTerm('lang', lang, 24 * 60 * 60 * 1000);
			if (apply) {
				window.location.reload();
			}
		}

		public static getLabel(lang:Lang):string {
			if (!this.isInitialized) {
				this.initialize();
			}
			return this.labelsByLang[lang];
		}

		private static initialize():void {
			this.labelsByLang = {};
			this.labelsByLang[Lang.ja] = '日本語';
			this.labelsByLang[Lang.en] = 'English';
			this.labelsByLang[Lang.zhHans] = '简体字'; // 簡体字
			this.labelsByLang[Lang.zhHant] = '繁體字'; // 繁体字
			this.labelsByLang[Lang.ko] = '한글';
			this.labelsByLang[Lang.th] = 'ภาษาไทย';
		}

		private static isInitialized:boolean = false;
		private static labelsByLang:Hash<string>;




		// --------------------------------------------------
		//
		// CONSTRUCTOR
		//
		// --------------------------------------------------

		private constructor() {
		}
	}
}
